<template>
  <section class="content">
    <!-- <keep-alive> -->
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div>
      <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
              <label for="toDate">Store</label>
              <Dropdown
                v-model="warehouseId"
                :options="warehouseLists"
                optionLabel="name"
                id="warehouse"
                :filter="true"
                placeholder="Select store"
                :showClear="true"
              />
            </div>

            <div class="p-field p-col-12 p-md-2 p-mt-5">
              <Button @click.prevent="searchUnsettledSales"
                      class="p-button-raised" label="Search" icon="pi pi-search"/>
            </div>
            <div class="p-field p-col-12 p-md-2 p-mt-5">
              <Button v-if="this.unPaidSalesLists.length > 0" @click.prevent="reset"
                      class="p-button-raised p-button-warning" icon="pi pi-refresh" label="Reset"/>
            </div>
          </div>
        </form>
        <a href="#" class="p-field p-col-12 p-md-12" @click.prevent="exportCSV()"
               v-if="this.unPaidSalesLists.length > 0">
              <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
            </a>

        <div class="p-field p-col-12 p-md-6">
          <label for="name">Total Unpaid Cash Sales R.s: <span style="color:red"></span></label>
          <label type="text" style="color:blue" ref="name">{{ this.cashSales }}</label>

          <label style="margin-left: 12%;" for="name">Total Unpaid Esewa Sales R.s: <span
            style="color:red"></span></label>
          <label type="text" style="color:blue" ref="name">{{ this.esewaSales }}</label>
        </div>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-col-12">
          
            <DataTable :value="unPaidSalesLists"  :selection.sync="selectedSalesOrderId"
                       :paginator="true" ref="po" editMode="cell"
                       :rows="100" :filters="filters"
                       :rowsPerPageOptions="[100,500,1000]"
                       class="p-datatable-responsive p-datatable-gridlines"
                       data-key="id">
                       <Column selectionMode="multiple" ></Column>
              <Column header="Date" :sortable="true" field="salesDate" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['salesDate']"/>
                </template>
              </Column>
              <Column header="Miti" :sortable="true" field="salesDateNepali" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['salesDateNepali']"/>
                </template>
              </Column>

              <Column header="Time" :sortable="true" field="time" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['time']"/>
                </template>
              </Column>

              <Column header="Bill No" :sortable="true" field="billPrefix" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billPrefix']"/>
                </template>
              </Column>
              <Column header="Customer" :sortable="true" field="customerName" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['customerName']"/>
                </template>
                <template #footer>
                  Total:
                </template>
              </Column>
              <Column header="Contact" :sortable="true" field="contactNumber" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']"/>
                </template>
              </Column>
              <Column header="Address" :sortable="true" field="deliveryAddress" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['deliveryAddress']"/>
                </template>
              </Column>
              <Column header="Pay status" bodyStyle="text-align: right" field="paymentStatus" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['paymentStatus']"/>
                </template>
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['paymentStatus']" :options="statusesPay"
                            @change="updatePaymentStatus(slotProps.data)"
                            optionLabel="label" optionValue="value" placeholder="Select a Status">
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template>
                  </Dropdown>
                </template>
                <template #body="slotProps">
                  {{ getPayStatusLabel(slotProps.data.paymentStatus) }}
                </template>
              </Column>
              <Column header="Pay Method" bodyStyle="text-align: right" field="paymentMethod" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['paymentMethod']"/>
                </template>
                <template #editor="slotProps">
                  <Dropdown v-model="slotProps.data['paymentMethod']" :options="payMethod"
                            @change="updatePaymentStatus(slotProps.data)"
                            optionLabel="label" optionValue="value" placeholder="Select a Status">
                    <template #option="slotProps">
                      <span>{{ slotProps.option.label }}</span>
                    </template>
                  </Dropdown>
                </template>
                <template #body="slotProps">
                  {{ getPaymentMethodLabel(slotProps.data.paymentMethod) }}
                </template>
              </Column>
              <Column header="Dis Amt" bodyStyle="text-align: right" field="discountAmount" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['discountAmount']"/>
                </template>
                <template #footer>
                  {{ totalDiscountAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Amount" bodyStyle="text-align: right" field="billAmount" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['billAmount']"/>
                </template>
                <template #footer>
                  {{ totalBillAmount.toFixed(2) }}
                </template>
              </Column>
              <Column header="Counter" bodyStyle="text-align: right" field="counterName" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['counterName']"/>
                </template>
              </Column>
              <Column header="Store" bodyStyle="text-align: right" field="warehouseName" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['warehouseName']"/>
                </template>
              </Column>

              <Column header="Entered By" bodyStyle="text-align: right" field="enteredBy" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['enteredBy']"/>
                </template>
              </Column>

              <Column header="Updated By" bodyStyle="text-align: right" field="updatedBy" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                </template>
              </Column>
              <Column header="Sent Sms" bodyStyle="text-align: right" field="updatedBy" :sortable="true"
                      filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                </template>
              </Column>
              <Column header="Action" >
                <template #body="slotProps">
                  <Button class="p-button-raised p-button-danger" v-tooltip.top="'Delete'"
                          @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/>
                  <!-- <Button v-else disabled class="p-button-raised p-button-danger"
                 @click="openDialog(slotProps.data.id)" icon="pi pi-trash"/> -->
                  <Button icon="pi pi-eye" class="p-button-raised p-button-warning" v-tooltip.top="'View Details'"
                          @click.prevent="viewUnsettleDetail(slotProps.data)"/>
                  <Button icon="pi pi-print" class="p-button-raised"  v-tooltip.top="'Print Bill'"
                          @click="printPage(slotProps.data)"/>
                          <Button icon="pi pi-ticket" class="p-button-raised" v-tooltip.top="'Pint KOT'"
                          @click="printKOTPage(slotProps.data)"/>
                  <Button icon="fa fa-truck" v-if="slotProps.data.deliveryAddress !== ''"  v-tooltip.top="'Delivery'"
                          class="p-button-raised"
                          @click="printDeliveryPage(slotProps.data)"/>
                  <Button icon="pi pi-refresh" v-if="slotProps.data.deliveryAddress !== ''" v-tooltip.top="'Exchange'"
                          class="p-button-raised p-button-secondary"
                          @click="printExchangePage(slotProps.data)"/>
                </template>
              </Column>
              <template #empty>No record found</template>
            </DataTable>
            <div class="p-grid p-col-12 p-md-3 p-mt-2">
      <Button  class="p-button-raised p-button-success" label="Send Notification"
           @click.prevent="openDeliceryDetailsDialog()"/>
    </div>
          </div>
        </div>
      </div>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteReport"/>
    <Dialogs header="Delivery Details" :visible.sync="delivertDialog"
           :style="{width: '50vw'}" :modal="true" :closable=false :contentStyle="{'overflow': 'visible'}">
           <div class="col-md-12">
             <label for="reason" class="col-md-4 control-label">Delivery Contact Number</label>
             <div class="form-group col-md-8">
               <textarea class="form-control"  rows="4" v-model="deliveryNumber"></textarea>
             </div>
           </div>
           <template #footer>
             <Button class="p-button-raised p-button-success" @click.prevent="sendSms" label="Send Sms"/>
             <Button class="p-button-raised p-button-success" @click.prevent="sendMail" label="Send Mail"/>
             <Button class="p-button-raised p-button-danger" @click.prevent="cancelSendSms" label="Cancel"/>
           </template>
         </Dialogs>
  </section>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dropdown from 'primevue/dropdown'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import InputMask from 'primevue/inputmask'
import Dialog from '../../layout/dialog'
import $ from 'jquery'
import Dialogs from 'primevue/dialog'

export default {
  name: 'POSUnPaidReport',
  data() {
    return {
      fromDate: null,
      // toDate: null,
      loading: false,
      filters: {},
      selectedSalesOrderId: null,
      idsForOrderPrint: [],
      delivertDialog: false,
      dialogShow: false,
      cashSales: 0,
      esewaSales: 0,
      statusesPay: [{label: 'Paid', value: 'Paid'}, {label: 'Unpaid', value: 'Unpaid'}],
      payMethod: [{label: 'Cash', value: 'CASH'}, {label: 'Esewa', value: 'ESEWA'}, {label: 'Fonepay', value: 'FONEPAY'}, {label: 'Khalti', value: 'Khalti'}, {label: 'Bank', value: 'Bank'}, {label: 'Ncm', value: 'Ncm'}],
      warehouseId: '',
      columnList: '',
      totalDiscountAmount: 0,
      totalBillAmount: 0
    }
  },
  computed: {
    unPaidSalesLists() {
      return this.$store.state.pos.unPaidSalesLists
    },
    warehouseLists() {
      return this.$store.state.warehouse.warehouseDropDownList
    }
  },
  mounted() {
    this.checkEnglish()
    this.columnNames()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.checkEnableDelete()
    this.checkEnableSettle()
    this.warehouseList()
    this.setWarehouse()
    this.totalBalance()
  },
  methods: {
    async searchUnsettledSales() {
      if (this.warehouseId !== '' && this.warehouseId !== null) {
        this.id = this.warehouseId.id
      } else {
        this.id = '0'
      }
      let date = {
        warehouse: this.id
        // toDate: this.toDate
      }
      this.loading = !this.loading
      let resp = await this.$store.dispatch('loadUnpaidLists', date)
      this.loading = false
      if (resp.data.data.length > 0) {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 3000})
        this.returnTotalSales()
        this.totalBalance()
      } else if (resp.data.data.length === 0) {
        this.$toast.add({severity: 'warn', summary: '', detail: 'No data available!', life: 3000})
        this.cashSales = 0.0
        this.esewaSales = 0.0
      }
    },
    async updatePaymentStatus(data) {
      let payment = {
        id: data.id,
        status: data.paymentStatus,
        method: data.paymentMethod
      }
      let response = await this.$store.dispatch('paymentStatusUpdate', payment)
      if (response.data.status === 'SUCCESS') {
        this.$toast.add({
          severity: 'success',
          summary: '',
          detail: 'Payment Status' + response.data.message,
          life: 3000
        })
      }
      // // debugger
    },
    totalBalance() {
      this.totalBillAmount = 0.0
      this.totalDiscountAmount = 0.0
      for (let sale of this.unPaidSalesLists) {
        this.totalBillAmount += sale.billAmount
        this.totalDiscountAmount += sale.discountAmount
      }
    },
    openDeliveryDialog() {
      this.delivertDialog = true
    },
    async sendSms() {
      this.loading = !this.loading
      if (this.selectedSalesOrderId !== null) {
        this.selectedSalesOrderId.forEach(salesOrderId => this.idsForOrderPrint.push(salesOrderId.id))
      }
      if (this.idsForOrderPrint.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one sales!', life: 10000})
        return
      }
      let date = {
        idsForSms: this.idsForOrderPrint,
        deliveryNumber: this.deliveryNumber
      }
      let response = await this.$store.dispatch('sendDeliverySms', date)
      console.log(response)
      // if (response.data.status === 'SUCCESS') {
      this.$toast.add({
        severity: 'success',
        summary: '',
        detail: 'Sms Sent Successfully!',
        life: 3000
      })
      // }
      this.delivertDialog = false
      this.loading = false
      this.idsForOrderPrint = []
      this.selectedSalesOrderId = null
    },
    async sendMail() {
      this.loading = !this.loading
      if (this.selectedSalesOrderId !== null) {
        this.selectedSalesOrderId.forEach(salesOrderId => this.idsForOrderPrint.push(salesOrderId.id))
      }
      if (this.idsForOrderPrint.length <= 0) {
        this.$toast.add({severity: 'error', summary: '', detail: 'Please select atleast one sales!', life: 10000})
        return
      }
      let date = {
        idsForSms: this.idsForOrderPrint,
        deliveryNumber: this.deliveryNumber

        // toDate: this.toDate
      }
      let response = await this.$store.dispatch('sendDeliveryMail', date)
      console.log(response)
      // if (response.data.status === 'SUCCESS') {
      this.$toast.add({
        severity: 'success',
        summary: '',
        detail: 'Mail Sent Successfully!',
        life: 3000
      })
      // }
      this.delivertDialog = false
      this.loading = false
      this.idsForOrderPrint = []
      this.selectedSalesOrderId = null
    },
    setWarehouse() {
      if (this.$store.state.warehouseData.id > 0) {
        this.setWarehouseData = true
        this.warehouseId = this.$store.state.warehouseData
      } else if (this.warehouseLists.length === 1) {
        this.warehouseId = this.warehouseLists[0]
      }
    },
    openDeliceryDetailsDialog() {
      this.delivertDialog = true
      this.deliveryNumber = ''
    },
    async warehouseList() {
      await this.$store.dispatch('loadWarehouseDropDown')
    },
    async deleteReport(value) {
      if (value.trim() === '') {
        this.$toast.add({severity: 'success', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRe = {
        id: this.posSalesId,
        deleteReason: value
      }
      let resp = await this.$store.dispatch('deletePosSales', deleteRe)
      if (resp.data.status === 'SUCCESS') {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      }
      this.dialogShow = false
    },
    returnTotalSales() {
      this.cashSales = this.unPaidSalesLists[this.unPaidSalesLists.length - 1].totalCashUnPaidSales
      this.esewaSales = this.unPaidSalesLists[this.unPaidSalesLists.length - 1].totalEsewaUnPaidSales
    },
    printPage(data) {
      data.printTyp = 'bill'
      this.$router.push({name: 'posPrintPage', params: {printData: data}})
    },
    printKOTPage(data) {
      data.printTyp = 'qott'
      this.$router.push({name: 'posPrintPage', params: {printData: data}})
    },
    printDeliveryPage(data) {
      this.$router.push({name: 'posDeliveryPrint', params: {printData: data}})
    },
    printExchangePage(data1) {
      data1.billAmount = 0
      this.$router.push({name: 'posDeliveryPrint', params: {printData: data1}})
    },
    cancel(data) {
      this.dialogShow = false
    },
    cancelSendSms() {
      this.delivertDialog = false
      this.deliveryNumber = ''
    },
    openDialog(id) {
      this.dialogShow = true
      this.posSalesId = id
    },
    async viewUnsettleDetail(data) {
      // // debugger
      let UnsettledSales = {
        returningAmount: data.returningAmount,
        contactNumber: data.contactNumber,
        billPrefix: data.billPrefix,
        billNo: data.billNo,
        paymentMethod: data.paymentMethod,
        salesDateNepali: data.salesDateNepali,
        subTotalAmount: data.subTotal,
        nonTaxableAmount: data.nonTaxableAmount,
        taxableAmount: data.taxableAmount,
        vatAmount: data.vatAmount,
        billAmount: data.billAmount,
        vatTypeEnum: data.vatTypeEnum,
        tenderAmount: data.tenderAmount,
        discountAmt: data.discountAmount,
        childSalesDetailsDTOList: data.childSalesDetailsDTOList
      }
      this.$router.push({name: 'Unsettled Details', params: {UnsettledData: UnsettledSales}})
    },
    exportCSV() {
      let data = {
        fromDate: 'null',
        // toDate: this.toDate,
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelPosReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.fromDate + '/unPaid' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'unPaidPosSalesReport.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 1; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    getPayStatusLabel(payStatus) {
      switch (payStatus) {
        case 'Paid':
          return 'Paid'

        case 'Unpaid':
          return 'Unpaid'

        default:
          return 'NA'
      }
    },
    getPaymentMethodLabel(payMethod) {
      switch (payMethod) {
        case 'ESEWA':
          return 'Esewa'
        case 'CASH':
          return 'Cash'
        case 'FONEPAY':
          return 'Fonepay'
        case 'Khalti':
          return 'Khalti'
        case 'Bank':
          return 'Bank'
        case 'Ncm':
          return 'Ncm'
        default:
          return 'NA'
      }
    },
    reset() {
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.setNepaliDate()
      } else {
        this.setEnglishDate()
      }
      window.location.reload()
    },
    checkEnableDelete() {
      if (this.$store.getters.modules.includes(',5.13')) {
        this.enableDelete = true
      }
    },
    checkEnableSettle() {
      if (this.$store.getters.modules.includes(',7.11')) {
        this.enableSettle = true
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    }
  },
  components: {
    DatePicker,
    DataTable,
    Column,
    Dropdown,
    InputText,
    Button,
    InputMask,
    Dialog,
    Dialogs
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// posAllUnPaidReport.vue?880e371e